module.exports = {"helmetTitle":"Veloe - Editar Dados Pessoais","title":"Dados pessoais","subtitle":"Aqui você pode editar suas informações para deixar a gente sempre atualizado. :)","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","titleModalError":"Oops, problemas ao salvar suas alterações :("}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditUserData/data.json
// module id = 1718
// module chunks = 0